'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorTransform = require('prosemirror-transform');

// This is a copy of prosemirror-model/src/diff.js modified to ignore
// attributes and marks when comparing nodes

function findDiffStart(a, b, pos) {
  for (var i = 0;; i++) {
    if (i == a.childCount || i == b.childCount)
      { return a.childCount == b.childCount ? null : pos }

    var childA = a.child(i), childB = b.child(i);
    if (childA == childB) { pos += childA.nodeSize; continue }

    if (childA.type != childB.type) { return pos }

    if (childA.isText && childA.text != childB.text) {
      for (var j = 0; childA.text[j] == childB.text[j]; j++)
        { pos++; }
      return pos
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffStart(childA.content, childB.content, pos + 1);
      if (inner != null) { return inner }
    }
    pos += childA.nodeSize;
  }
}

function findDiffEnd(a, b, posA, posB) {
  for (var iA = a.childCount, iB = b.childCount;;) {
    if (iA == 0 || iB == 0)
      { return iA == iB ? null : {a: posA, b: posB} }

    var childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
    if (childA == childB) {
      posA -= size; posB -= size;
      continue
    }

    if (childA.type != childB.type) { return {a: posA, b: posB} }

    if (childA.isText && childA.text != childB.text) {
      var same = 0, minSize = Math.min(childA.text.length, childB.text.length);
      while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
        same++; posA--; posB--;
      }
      return {a: posA, b: posB}
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
      if (inner) { return inner }
    }
    posA -= size; posB -= size;
  }
}

// ::- A document range with metadata associated with it. Used to
// track both inserted and deleted ranges, though deletions are
// represented with a subclass.
var Span = function Span(from, to, data) {
  // :: number The start of this span.
  this.from = from;
  // :: number The end of the span.
  this.to = to;
  // :: any Data associated with this span.
  this.data = data;
};

// : ([Span], number, number, any, {compare: (any, any) → bool, combine: (any, any) → any}) → [Span]
// Updates an array of spans by adding a new one to it. Spans with
// different authors are kept separate. When the new span touches
// compatible (as per `config.compare` spans), it is joined with them.
// When it overlaps with incompatible spans, it overwrites those
// parts.
Span.add = function add (spans, from, to, data, config) {
  return addSpanInner(spans, from, to, data, config, true)
};

// : ([Span], number, number, any, {compare: (any, any) → bool, combine: (any, any) → any}) → [Span]
// Works like `addSpan`, but leaves overlapping spans in the existing
// data intact, shrinking/splitting the new span instead.
Span.addBelow = function addBelow (spans, from, to, data, config) {
  return addSpanInner(spans, from, to, data, config, false)
};

function addSpanInner(spans, from, to, data, config, above) {
  var inserted = null;

  for (var i = 0; i < spans.length; i++) {
    var span = spans[i], compat = config.compare(span.data, data);
    if (compat ? span.to < from : span.to <= from) {
      // Not there yet
    } else if (compat ? span.from > to : span.from >= to) {
      if (!inserted) { spans.splice(i, 0, inserted = new Span(from, to, data)); }
      break
    } else if (compat) {
      from = Math.min(from, span.from);
      to = Math.max(to, span.to);
      data = config.combine(span.data, data);
      spans.splice(i--, 1);
    } else if (above) { // New span overwrites existing ones
      if (span.from < from) { spans.splice(i++, 0, new Span(span.from, from, span.data)); }
      if (span.to > to) {
        spans.splice(i, 1, inserted = new Span(from, to, data), new Span(to, span.to, span.data));
        break
      } else {
        spans.splice(i--, 1);
      }
    } else { // New span only appears behind existing ones
      if (from < span.from) { spans.splice(i++, 0, new Span(from, span.from, data)); }
      if (to <= span.to) {
        inserted = true;
        break
      } else {
        from = span.to;
      }
    }
  }
  if (!inserted) { spans.push(new Span(from, to, data)); }
  return spans
}

// ::- Used to represent a deletion.
var DeletedSpan = (function (Span$$1) {
  function DeletedSpan(from, to, data, pos, slice) {
    Span$$1.call(this, from, to, data);
    // :: number The position of the deletion in the current document.
    this.pos = pos;
    // :: Slice The deleted content.
    this.slice = slice;
  }

  if ( Span$$1 ) DeletedSpan.__proto__ = Span$$1;
  DeletedSpan.prototype = Object.create( Span$$1 && Span$$1.prototype );
  DeletedSpan.prototype.constructor = DeletedSpan;

  return DeletedSpan;
}(Span));

// ::- An changeset tracks the changes to a document from a given
// point in the past. It condenses a number of step maps down to a
// flat sequence of insertions and deletions, and merges adjacent
// insertions/deletions that (partially) undo each other.
var ChangeSet = function ChangeSet(config, inserted, deleted) {
  this.config = config;
  // :: [Span]
  // Inserted regions. Their `from`/`to` point into the current
  // document.
  this.inserted = inserted;
  // :: [DeletedSpan]
  // Deleted ranges. Their `from`/`to` point into the old document,
  // and their `pos` into the new.
  this.deleted = deleted;
};

ChangeSet.prototype.getMap = function getMap () {
    var this$1 = this;

  var ranges = [];
  for (var iI = 0, iD = 0, off = 0;;) {
    var ins = iI == this$1.inserted.length ? null : this$1.inserted[iI];
    var del = iD == this$1.deleted.length ? null : this$1.deleted[iD];
    if (ins == null && del == null) { return new prosemirrorTransform.StepMap(ranges) }
    if (del == null || (ins != null && ins.from < del.pos)) {
      var size = ins.to - ins.from;
      ranges.push(ins.from + off, 0, size);
      off -= size;
      iI++;
    } else if (ins && ins.from == del.pos) {
      var dSize = del.to - del.from, iSize = ins.to - ins.from;
      ranges.push(del.pos + off, dSize, iSize);
      off += dSize - iSize;
      iI++;
      iD++;
    } else {
      var size$1 = del.to - del.from;
      ranges.push(del.pos + off, size$1, 0);
      off += size$1;
      iD++;
    }
  }
};

// :: (Node, [StepMap], union<[any], any>) → ChangeSet
// Computes a new changeset by adding the given step maps and
// metadata (either as an array, per-map, or as a single value to be
// associated with all maps) to the current set. Will not mutate the
// old set.
ChangeSet.prototype.addSteps = function addSteps (newDoc, maps, data) {
    var this$1 = this;

  // This works by inspecting the position maps for the changes,
  // which indicate what parts of the document were replaced by new
  // content, and the size of that new content. It maps all replaced
  // ranges backwards, to the start of the range of changes, and all
  // inserted ranges forward, to the end.
  //
  // The replaced ranges are added so that earlier deletions take
  // precedence (the first person to delete something is the one
  // responsible for its deletion), and the inserted ranges are
  // added so that later ones take precedence (the last person to
  // insert somewhere is responsible for the text there).
  //
  // The original document is then used to get a slice for each
  // deleted range, and the positions of those ranges are mapped
  // forward to positions in the resulting document.

  if (maps.length == 0) { return this }

  var inserted = [], deleted = [];
  var map = this.getMap(), mapI = map.invert();

  // Map existing inserted and deleted spans forward
  for (var i = 0; i < this.inserted.length; i++) {
    var span = this$1.inserted[i];
      var from = span.from;
      var to = span.to;
    for (var j = 0; j < maps.length && to > from; j++) {
      from = maps[j].map(from, 1);
      to = maps[j].map(to, -1);
    }
    if (to > from) { inserted.push(from != span.from || to != span.to ? new Span(from, to, span.data) : span); }
  }
  for (var i$1 = 0; i$1 < this.deleted.length; i$1++) {
    var span$1 = this$1.deleted[i$1], pos = span$1.pos;
    for (var j$1 = 0; j$1 < maps.length; j$1++) { pos = maps[j$1].map(pos, -1); }
    deleted.push(pos == span$1.pos ? span$1 : new DeletedSpan(span$1.from, span$1.to, span$1.data, pos, span$1.slice));
  }

  // Add spans for new steps.
  var newBoundaries = []; // Used to make sure new insertions are checked for merging
  var loop = function ( i, dI ) {
    // Map deletions backward to the original document, and add them
    // to `deleted`
    maps[i].forEach(function (fromA, toA, fromB, toB) {
      for (var j = i - 1; j >= 0 && toA > fromA; j--) {
        var inv = maps[j].invert();
        fromA = inv.map(fromA, 1);
        toA = inv.map(toA, -1);
      }
      if (toA > fromA) {
        fromA = mapI.map(fromA, 1);
        toA = mapI.map(toA, -1);
        if (toA > fromA)
          { Span.addBelow(deleted, fromA, toA, Array.isArray(data) ? data[dI] : data, this$1.config); }
      }

      // Map insertions forward to the current one, and add them to
      // `inserted`.
      for (var j$1 = i + 1; j$1 < maps.length && toB > fromB; j$1++) {
        fromB = maps[j$1].map(fromB, 1);
        toB = maps[j$1].map(toB, -1);
      }
      if (toB > fromB) {
        newBoundaries.push(fromB, toB);
        Span.add(inserted, fromB, toB, Array.isArray(data) ? data[dI] : data, this$1.config);
      }
    });
  };

    for (var i$2 = 0, dI = 0; i$2 < maps.length; i$2++, dI++) loop( i$2, dI );

  // Restore the pos and slice on deleted spans that have been
  // updated, and merge deleted slices with adjacent insertions when
  // possible.
  for (var i$3 = 0, j$2 = 0; i$3 < deleted.length; i$3++) {
    var span$2 = deleted[i$3], merge = false;
    if (!span$2.slice) {
      var pos$1 = map.map(span$2.from, -1);
      for (var k = 0; k < maps.length; k++) { pos$1 = maps[k].map(pos$1, -1); }
      deleted[i$3] = span$2 = new DeletedSpan(span$2.from, span$2.to, span$2.data, pos$1,
                                          this$1.config.doc.slice(span$2.from, span$2.to));
      merge = true;
    } else {
      merge = newBoundaries.indexOf(span$2.pos) > -1;
    }

    // Check for adjacent insertions/deletions with compatible data
    // that fully or partially undo each other, and shrink or delete
    // them to clean up the output.
    if (merge) { for (var nextJ = (void 0); j$2 < inserted.length; j$2 = nextJ) {
      var next = inserted[j$2];
      nextJ = j$2 + 1;
      if (next.from > span$2.pos) { break }
      if (next.from < span$2.pos || !this$1.config.compare(span$2.data, next.data)) { continue }

      var slice = newDoc.slice(next.from, next.to);
      var sameStart = sliceSameTo(span$2.slice, slice);
      if (sameStart > 0) {
        var dropNext = sameStart >= next.to - next.from;
        if (dropNext) { inserted.splice(--nextJ, 1); }
        else { inserted[j$2] = next = new Span(next.from + sameStart, next.to, next.data); }
        if (sameStart >= span$2.to - span$2.from) { deleted.splice(i$3--, 1); break }
        deleted[i$3] = span$2 = new DeletedSpan(span$2.from + sameStart, span$2.to, span$2.data, span$2.pos + sameStart,
                                            this$1.config.doc.slice(span$2.from + sameStart, span$2.to));
        if (dropNext) { continue }
        slice = newDoc.slice(next.from, next.to);
      }
      var sameEnd = sliceSameFrom(span$2.slice, slice);
      if (sameEnd > 0) {
        if (sameEnd >= next.to - next.from) { inserted.splice(--nextJ, 1); }
        else { inserted[j$2] = new Span(next.from, next.to - sameEnd, next.data); }
        if (sameEnd >= span$2.to - span$2.from) { deleted.splice(i$3--, 1); break }
        deleted[i$3] = span$2 = new DeletedSpan(span$2.from, span$2.to - sameEnd, span$2.data, span$2.pos,
                                            this$1.config.doc.slice(span$2.from, span$2.to - sameEnd));
      }
    } }
  }

  return new ChangeSet(this.config, inserted, deleted)
};

// :: (Node, ?Object) → ChangeSet
// Create a changeset with the given base object and
// configuration. The `compare` and `combine` options should be
// functions, and are used to compare and combine metadata—`compare`
// determines whether two spans are compatible, and when they are,
// `combine` will compute the metadata value for the merged span.
ChangeSet.create = function create (doc, ref) {
    if ( ref === void 0 ) ref = {};
    var compare = ref.compare; if ( compare === void 0 ) compare = function (a, b) { return a == b; };
    var combine = ref.combine; if ( combine === void 0 ) combine = function (a) { return a; };

  var config = {compare: compare, combine: combine, doc: doc};
  return new ChangeSet(config, [], [])
};

function sliceSameTo(a, b) {
  var openA = a.openStart, openB = b.openStart, fragA = a.content, fragB = b.content;
  for (; openA > openB; openA--) { fragA = fragA.firstChild.content; }
  for (; openB > openA; openB--) { fragB = fragB.firstChild.content; }
  var start = findDiffStart(fragA, fragB, 0);
  return Math.min(a.size, b.size, (start == null ? fragA.size : start) - openA)
}

function sliceSameFrom(a, b) {
  var openA = a.openEnd, openB = b.openEnd, fragA = a.content, fragB = b.content;
  for (; openA > openB; openA--) { fragA = fragA.lastChild.content; }
  for (; openB > openA; openB--) { fragB = fragB.lastChild.content; }
  var end = findDiffEnd(fragA, fragB, fragA.size, fragB.size);
  return Math.min(a.size, b.size, fragA.size - (end ? end.a : 0) - openA)
}

exports.Span = Span;
exports.DeletedSpan = DeletedSpan;
exports.ChangeSet = ChangeSet;
